/**
 * Base class for all streaming-related exceptions
 */
export class StreamingException extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly details?: any
  ) {
    super(message);
    this.name = this.constructor.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/**
 * Thrown when authentication fails during streaming connection
 */
export class StreamingAuthenticationException extends StreamingException {
  constructor(message: string = 'Authentication failed', details?: any) {
    super(message, 'STREAMING_AUTH_ERROR', details);
  }
}

/**
 * Thrown when the network connection is lost during streaming
 */
export class StreamingConnectionException extends StreamingException {
  constructor(message: string = 'Connection lost during streaming', details?: any) {
    super(message, 'STREAMING_CONNECTION_ERROR', details);
  }
}

/**
 * Thrown when data parsing fails
 */
export class StreamingParseException extends StreamingException {
  constructor(message: string = 'Failed to parse streaming data', details?: any) {
    super(message, 'STREAMING_PARSE_ERROR', details);
  }
}

/**
 * Thrown when streaming is aborted by user or application
 */
export class StreamingAbortedException extends StreamingException {
  constructor(message: string = 'Streaming aborted', details?: any) {
    super(message, 'STREAMING_ABORTED', details);
  }
}

/**
 * Thrown for unknown or unexpected errors
 */
export class StreamingUnknownException extends StreamingException {
  constructor(message: string = 'Unknown error during streaming', details?: any) {
    super(message, 'STREAMING_UNKNOWN_ERROR', details);
  }
}
